import { useContext } from 'react';

import { TwilioContext } from '../../../context-providers/TwilioContext';

export const useActiveCalls = () => {
  const { calls } = useContext(TwilioContext);

  // Filter active calls (including on-hold)
  const activeCalls = calls.filter((call) => {
    const status = call.status();
    return ['connecting', 'open', 'reconnecting', 'ringing', 'pending'].includes(status);
  });

  const hasActiveCalls = activeCalls.length > 0;

  return {
    activeCalls,
    hasActiveCalls,
  };
};
